import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import ErrorDialogContent from './content';
import analytics from '../../utils/analytics';
import { Partner } from '../LeadFormIndex/types';

type ClaveUnicaErrorDialogProps = {
  errors:{
  isPasswordError: boolean,
  isDataExtractionError: boolean,
  isBlockedPasswordError: boolean,
  isMaintenanceError: boolean,
  isAFCBlockedPasswordError: boolean,
  isNotSubscribedError: boolean,
  isConnectionError: boolean,
  isExternalInformationError: boolean,
  },
  numTries: number,
  retryCUSubmit: () => void,
  partner: Partner,
}

export default function ClaveUnicaErrorDialog(props: ClaveUnicaErrorDialogProps) {
  const {
    errors,
    numTries,
    retryCUSubmit,
    partner,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [errorState, setErrorState] = React.useState<any[]>(['']);

  const handleClose = () => {
    setOpen(false);
  };

  const getDialogTitle = () => {
    if (errorState[0] === 'dataExtractionError') return 'Vuelve mas tarde';
    return numTries > 2 ? 'Falta información' : 'Volver a ingresar ClaveÚnica';
  };

  const retry = () => {
    analytics.track('Click boton', {
      text: 'Reintentar',
      initiator: 'usuario',
    });
    handleClose();
    retryCUSubmit();
  };
  React.useEffect(() => {
    if (Object.values(errors).some((err) => err)
    ) {
      if (errors.isPasswordError) {
        setErrorState(['passwordError', partner.partnerName, undefined, numTries]);
      }
      if (errors.isBlockedPasswordError) {
        setErrorState(['blockedPassword', partner.partnerName]);
      }
      if (errors.isMaintenanceError) {
        setErrorState(['maintenanceError', partner.partnerName]);
      }
      if (errors.isAFCBlockedPasswordError) {
        setErrorState(['afcBlockedPassword', partner.partnerName]);
      }
      if (errors.isNotSubscribedError) {
        setErrorState(['notSubscribedError', partner.partnerName]);
      }
      if (errors.isConnectionError) {
        setErrorState(['connectionError', partner.partnerName, retry]);
      }
      if (errors.isDataExtractionError) {
        setErrorState(['dataExtractionError', partner.partnerName, undefined, numTries]);
      }
      if (errors.isExternalInformationError) {
        setErrorState(['externalInformationError', partner.partnerName]);
      }
      setOpen(true);
    }
  }, [errors]);

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <b>{getDialogTitle()}</b>
      </DialogTitle>
      <DialogContent>
        {ErrorDialogContent({
          errorType: errorState[0],
          partner: errorState[1],
          retry: errorState[2],
          numTries: errorState[3],
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
